<div class="row">
    <ng-container *ngIf="podcastIsNextEpisode">
        <a class="col-sm-3 btn-org" *ngFor="let p of podcastIsNextEpisode"
            (click)="changeTypeOfPodcast(p.id,p.nextEpisode)" [ngClass]="{'active': selectedItem == p.id}"
            style="color: black;">{{p.title}}</a>
    </ng-container>
</div>
<br>

<div class="row">
    <div class="col-sm-6">
        <h4>Lista de podcast</h4>
    </div>
    <div class="col-sm-6 text-end">

        <a [routerLink]="'../add-info/' + idPodcast" class="btn-add" *ngIf="createText">
            <i class="fa fa-plus px-2"></i> Texto introductorio
        </a>

        <a routerLink="../add" class="btn-add" *ngIf="accessMP">
            <i class="fa fa-plus px-2"></i> Agregar nuevo
        </a>
    </div>
    <div class="container my-1">
        <div class="filter-bar row g-1 p-3">
            <div class="col-12 col-md-6">
                <input type="text" [(ngModel)]="filters.searchText" placeholder="Buscar por título o episodio"
                    (input)="applyFilter()" class="form-control filter-input" />
            </div>
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.estado" (change)="applyFilter()" class="form-select filter-select">
                    <option [ngValue]="null">Todos los estados</option>
                    <option [ngValue]="true">Activo</option>
                    <option [ngValue]="false">Inactivo</option>
                </select>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Título</th>
                    <th scope="col">Episodio</th>
                    <th scope="col">Descripcion</th>
                    <th scope="col">URL Spotify</th>
                    <th scope="col">Estado</th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <th scope="col"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let p of filteredData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ p.name }}</td>
                    <td>{{ p.episode }}</td>
                    <td>{{ p.description }}</td>
                    <td>{{ p.urlSpotify }}</td>
                    <td class="text-center">
                        <div class="label-active text-center" *ngIf="p.status">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!p.status">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/podcast/edit', p.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <td class="text-center"><a class="a-icon" (click)="delForum(p.id, this.selectedItem)"><i
                                    class="fa fa-trash i-icon"></i></a>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div id="popup" class="popup">
    <span id="message">Se eliminó el registro</span>
</div>